import { jsx as p } from "@emotion/react/jsx-runtime";
import { SingleSelect as O } from "@partoohub/ui";
import { useBusinessModalContext as S } from "../../../../../BusinessModalContext.js";
import { useOrganizationSection as f } from "../../../../../hooks/options/useOrganizationSection.js";
import { useOrganizations as v } from "../../../../../hooks/useOrganizations.js";
import { setSearchQueryOrganization as x, setSearchOrg as b } from "../../../../../reducer/businessModal.actions.js";
const Q = () => {
  const {
    dispatch: o,
    translations: i,
    preFilters: t
  } = S(), {
    query: r
  } = v(), s = f() ?? [], l = () => {
    const e = t?.searchOrg;
    if (!e) return;
    const a = s.flatMap((n) => n.options).find((n) => t.searchOrg === n.value);
    return a ? {
      value: a.value,
      name: a.name,
      label: a.value
    } : {
      value: e,
      name: e,
      label: e
    };
  }, {
    hasNextPage: c,
    isFetchingNextPage: g,
    isLoading: h
  } = r, u = (e) => {
    o(b(e));
  }, m = () => {
    r.fetchNextPage();
  }, d = (e) => {
    o(x(e));
  };
  return /* @__PURE__ */ p(O, { dataTrackId: "business_modal__multiselect", maxHeight: 300, sections: s, selectedValue: l(), onChange: u, label: i.organizations, hasMore: c, searchValue: t?.searchQueryOrganization ?? "", onSearch: d, loadMore: m, isLoading: g || h });
};
export {
  Q as SelectOrgs
};
